<template>
  <component class="Tag-SmartContract" :class="get_modify" :is="get_tag" :href="get_href" target="_blank">
    <AvatarImage class="Tag-SmartContract__contract-icon" :src="props.image" :size="16" :alt="'resource'"/>
    <span class="Tag-SmartContract__contract">{{ shortenedContract }}</span>
    <Copy class="Tag-SmartContract__copy-icon" @click="handleCopyClick"/>
  </component>
</template>

<script setup>
import {useStore} from "vuex";
import {defineProps, computed} from 'vue';
import {Props} from './scripts/props.js';
import { callOverlay } from '@/Groups/OverlayManager/public/utils/callOverlay.js';
//-----------------------------------------------
import AvatarImage from '@ui/Images/AvatarImage/AvatarImage.vue';
import Copy from '@svg/Copy.vue'
//-----------------------------------------------
const props = defineProps(Props());
const store = useStore();
//-----------------------------------------------
//Определить, блок является ссылкой?
const get_tag = computed(() => props.link ? 'a' : 'span');
//Определить класс модификатор
const get_modify = computed(() => props.link ? 'Tag-SmartContract--link' : '');
//Определить атрибут href
const get_href = computed(() => props.link ? props.link : null);
//-----------------------------------------------
// Метод для сокращения адреса контракта
const shortenAddress = (address) => {
  if (!address) return '';
  return `${address.slice(0, 6)}...${address.slice(-4)}`;
};
// Метод для обработки клика по иконке "Copy"
const handleCopyClick = (event) => {
  event.stopPropagation(); // Остановить всплытие события клика
  event.preventDefault(); // Предотвратить действие ссылки
  copyToClipboard();
};
// Метод копирования контракта
const copyToClipboard = () => {
  if (props.contract) {
    navigator.clipboard.writeText(props.contract)
        .then(() => {
          callOverlay({ text: 'Адрес скопирован', color: 'green', icon: 'copy' });
        })
        .catch((error) => {
          console.error('Failed to copy address:', error);
          callOverlay({ text: 'Ошибка при копировании', color: 'red', icon: 'copy' });
        });
  }
};
// Сокращенный адрес контракта
const shortenedContract = computed(() => shortenAddress(props.contract));
</script>

<style lang="scss">
@import "./styles/_conf";
</style>
